import clsx from "clsx"
import { ReactNode } from "react"

interface CTATextProps {
	href: string
	children: ReactNode
	className?: string
}

const CTAText = ({ href, children, className }: CTATextProps) => {
	return (
		<a
			href={href}
			className={clsx("cursor-default text-accent-600 hover:text-accent-500", className)}
			target="_blank"
			rel="noopener noreferrer"
		>
			{children}
		</a>
	)
}

export default CTAText
